(function ($) {
    $(document).ready(function () {
        $('.shuffle-slider  .slider-box .slide-box').slick({
            centerMode: true,
            centerPadding: '20px',
            slidesToShow: 1,
            infinite: true,
            dots: true,
            dotsClass: 'custom-dots',
            arrows: false,
            speed: 700,
            autoplay: false,
            focusOnSelect: true,
            responsive: [
                {
                    breakpoint: 991,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '40px',
                        slidesToShow: 1
                    }
                },
                {
                    breakpoint: 574,
                    settings: {
                        arrows: false,
                        centerMode: true,
                        centerPadding: '20px',
                        slidesToShow: 1
                    }
                }
            ]
        });

    });

})(jQuery);